<template>
    <div>
        <el-dialog
            append-to-body
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :before-close="handleClose"
                :visible.sync="dialogShow"
                width="50%"
                :modal-append-to-body="false">
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        开 始
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                        <el-divider></el-divider>
                </template>
            <avue-form
                :option="option"
                v-model="form"
                v-if="dialogShow"
                @submit="formSubmit"
                @error="formError">
                <template slot="areaId">
                    <el-select
                            v-model="form.areaId"
                            placeholder="请选择 需求区域"
                            ref="addConnectSelect"
                            >
                            <el-option :value="form.areaId" show-all-levels :label="form.areaName">
                                <el-tree
                                    node-key="id"
                                    :data="treeFormAreaData"
                                    :props="treeProps"
                                    :load="editAreaLazyLoadTree"
                                    lazy
                                    @node-click="editAreaNodeTreeClick_"
                                >
                                </el-tree>
                            </el-option>
                    </el-select>
                </template>
                 <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入 备注"
                                v-model="form.remark">
                            </el-input>
                            <remarkModel :remark.sync="form.remark" ref="scrapFormRemarkModel"></remarkModel>
                        </div>
                    </template>
                <template slot="attachList">
                    <div>
                        <vupload :fileList.sync="form.attachList"></vupload>
                    </div>
                </template>
                <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取 消</el-button>
                </template>
            </avue-form>
        </el-dialog>
    </div>
</template>
<script>
import {
    startOption,
} from "./option.js";
import {
        getRemarkList,
        start,
        lazyAreaTree
 } from "@/api/gateservice/order/order-list/order-list";
import remarkModel from "../components/remark-model";
import vupload from "@/views/components/v-upload";
import {fieldDetail} from "@/api/v4ward/ordersetting/setting/selfForm"
export default {
    components:{
        remarkModel,vupload
    },
    data(){
        return{
            dialogFull:false,
            form:{
                orderId:'',
                attachList:[],
                areaId:'',
            },
            treeFormAreaData:[],//懒加载区域树 --报修表单中
            treeProps: {//报修表单 --需求区域树的配置
                //标题
                label: 'name',
                //值
                value: 'id',
                //子节点
                children: 'zones',
                //是否叶子节点
                isLeaf: 'hasChildren',
                //本节点类型key值
                objectType: 'id',
                //本节点类型名
                objectTypeName: 'name',
            },
            data:{},
            cheackedPeople:[],
            userList:[],
            dialogShow:false,
            option:startOption,
            orderRow:{},
            imgRequireFlag:false
        }
    },
    created(){

    },
    methods:{
         //获取字段填写修饰
        async getFieldDetail(projectId,moduleType,actionType){
            console.log("执行了")
            let obj = {
                projectId:projectId,
                moduleType:moduleType,
                actionType:actionType
            }
            let fieldObj
            fieldObj  = this.findObject(this.option.column,'remark')
            let fieldEstimateEndTime = this.findObject(this.option.column,'estimateEndTime')
            await fieldDetail(obj).then(res=>{
                let resDescript
                let resAttach
                let resEstimateEndTime
                res.data.forEach(item=>{
                    if(item.fieldCode == "description"){
                        resDescript =item
                    }
                    if(item.fieldCode=="uploadFile"){
                        resAttach = item
                    }
                    if(item.fieldCode == "estimateEndTime"){
                        resEstimateEndTime = item
                    }
                })
                if(resDescript){
                    if( resDescript.defaultMustFlag ==0){

                        fieldObj.rules[0].required=false
                    }else{
                        fieldObj.rules[0].required=true
                    }
                }
                if(resEstimateEndTime){
                    if( resEstimateEndTime.defaultMustFlag ==0){

                        fieldEstimateEndTime.rules[0].required=false
                    }else{
                        fieldEstimateEndTime.rules[0].required=true
                    }
                }

                if(resAttach){
                    if( resAttach.defaultMustFlag ==0){

                        this.imgRequireFlag=false
                    }else{
                        this.imgRequireFlag=true
                    }
                }



            })
        },
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {

                        self.dialogShow = false;

                })
                .catch(()=> {

                });
        },
        openDialog(data){
            this.dialogShow = true;
            this.orderRow = data.orderRow
            this.getFieldDetail(this.orderRow.projectId,this.orderRow.moduleType,5)
            console.log("openDialog")
            this.data = data;
            this.form = {
                orderId:data.orderId,
                attachList:[],
                areaName:'',
                areaId:''
            }
            getRemarkList({orderId:data.orderId,actionType:data.actionType}).then(res=>{
                this.$refs.scrapFormRemarkModel.setRemarkList(res.data);
            })
        },
        closeDialog(){
            this.dialogShow = false;
        },
        formError(done){
            done()
        },
        formSubmit(form,done){
            if(this.imgRequireFlag){
                if(this.form.attachList.length==0){
                    this.$message.error("附件不能为空")
                    done()
                    return
                }
            }
            // let temForm = form;
            // temForm.orderId = form.orderId;
            // temForm.cooperateList = form.remark;

            start(form).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                     this.dialogVisible = false;
                     this.dialogShow = false;
                }else{
                    this.$message.error(res.msg);
                }
                this.$emit('handleClose',function(){console.log('关闭历程表')})

                this.dialogShow = false;
                done()
            }).catch(err=>{


                done()
            })
        },
        // 报修表单  -- 服务地点切换
        editAreaNodeTreeClick_(node){
            if(parseInt(node.nodeType)==1){
            // this.$message.error();
                return;
            }
            setTimeout(() => {
                let nodeId = node.id;
                let nodeTitle = node.name;
                // this.form.areaName = nodeTitle;
                // this.form.areaId = nodeId;

                    this.form = Object.assign({}, this.form,{
                    'areaName':nodeTitle,
                    "areaId":nodeId});
                    this.$refs.addConnectSelect.blur();

            }, 0);
        },
        // 报修表单  --服务地点数据
        editAreaLazyLoadTree(node, resolve) {
            let id;
            if (node.level === 0) {
                id = 0;
            } else {
                id = node.data.id;
            }
            lazyAreaTree({ parentId: id, projectId: this.data.projectId}).then(({ data }) => {
                if (data instanceof Array ) {
                    data.forEach(item => {
                    item.hasChildren = !item.hasChildren;
                    })
                }
                resolve(data);
            });
        },
    }
}
</script>
